export default "__VITE_PUBLIC_ASSET__4f78adbc__"